<template>
  <v-dialog
    data-qa="fullscreen-dialog"
    transition="dialog-bottom-transition"
    :model-value="isActive"
    :persistent="persistent"
    :fullscreen="isFullscreen"
    :width="dialogWidth"
    :max-width="dialogWidth"
    @click:outside="handleClose"
    @keydown="handleClose"
    @update:model-value="handleUpdateModelValue"
  >
    <v-card>
      <AppToolbar
        :title="title"
        :has-close-button="!hasBackButton"
        :has-back-button="hasBackButton"
        :borderless="borderless"
        @click:close="handleClose"
        @click:back="emit('click:back')"
      />
      <!-- @slot Основное содержимое -->
      <slot />
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'
/**
 * Является оберткой v-dialog. Служит для отображения стандартной модалки с шапкой.
 */

const props = defineProps({
  /** Определяет, активен ли диалог. */
  isActive: { type: Boolean, default: false },

  /** Определяет, есть ли кнопка "Назад" у диалога. */
  hasBackButton: { type: Boolean, default: false },

  /**
   * Определяет, является ли диалог persistent
   * @see https://vuetifyjs.com/en/api/v-dialog/#props-persistent
   */
  persistent: { type: Boolean, default: false },

  /** Заголовок в шапке диалога. */
  title: { type: String, default: '' },

  /** Определяет, отсутствует ли нижняя граница у шапки диалога. */
  borderless: { type: Boolean, default: false },

  /** Определяет, будет ли диалог во весь экран для лубого размера экрана */
  fullscreen: { type: Boolean, default: false },

  /** Ширина диалога когда он не во весь экран */
  width: { type: [Number, String], default: 'auto' },
})

const emit = defineEmits(['click:close', 'click:back'])

const display = useDisplay()

const isFullscreen = computed(() => props.fullscreen || display.xs.value)
const dialogWidth = computed(() => isFullscreen.value ? undefined : props.width)

function handleUpdateModelValue() {
  if (props.isActive) {
    emit('click:close')
  }
}

function handleClose() {
  emit('click:close')
}
</script>
